import {useAuth0} from "@auth0/auth0-react";
import {VoiceTrainingScriptDTO} from "../model/voice_training_script";

export function useVoiceTrainingScriptAPI() {
    const {getAccessTokenSilently} = useAuth0();

    const getAllScripts = async (): Promise<VoiceTrainingScriptDTO[]> => {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_API_URL}/voice-training-scripts/admin`, {
            headers: {
                authorization: `Bearer ${accessToken}`,
            },
        });

        if (response.status === 200) {
            return response.json();
        } else {
            throw new Error("Failed to fetch voice training scripts: " + response.statusText);
        }
    };

    const getScriptById = async (id: string): Promise<VoiceTrainingScriptDTO> => {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_API_URL}/voice-training-scripts/admin/${id}`, {
            headers: {
                authorization: `Bearer ${accessToken}`,
            },
        });

        if (response.status === 200) {
            return response.json();
        } else {
            throw new Error("Failed to fetch voice training script: " + response.statusText);
        }
    };

    const createScript = async (script: VoiceTrainingScriptDTO): Promise<VoiceTrainingScriptDTO> => {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_API_URL}/voice-training-scripts/admin`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(script),
        });

        if (response.status === 200) {
            return response.json();
        } else {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.message || "Failed to create voice training script: " + response.statusText);
        }
    };

    const updateScript = async (id: string, script: VoiceTrainingScriptDTO): Promise<VoiceTrainingScriptDTO> => {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_API_URL}/voice-training-scripts/admin/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(script),
        });

        if (response.status === 200) {
            return response.json();
        } else {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.message || "Failed to update voice training script: " + response.statusText);
        }
    };

    const deleteScript = async (id: string): Promise<VoiceTrainingScriptDTO> => {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_API_URL}/voice-training-scripts/admin/${id}`, {
            method: "DELETE",
            headers: {
                authorization: `Bearer ${accessToken}`,
            },
        });

        if (response.status === 200) {
            return response.json();
        } else {
            throw new Error("Failed to delete voice training script: " + response.statusText);
        }
    };

    return {
        getAllScripts,
        getScriptById,
        createScript,
        updateScript,
        deleteScript,
    };
}

